import {
  fetchFinance,
  fetchOperation,
  getOperation,
  postProcessorOnboard,
} from "utils/api";

export const validateMcc = async (params) => {
  return await postProcessorOnboard("/validate-mcc", params);
}

export const createMerchant = async (params) => {
  return await fetchOperation("/merchant/detail", params);
}

export const addMdrMerchant = async (params) => {
  return await fetchFinance("/action", {
    ...params,
    method: "post",
    action: "addMerchant",
  });
}

export const onboardProcessors = async (params) => {
  return await postProcessorOnboard("/merchants/sqs", {
    ...params,
    onboardType: "MAS_ONBOARD",
  });
}

export const queryAgentOptions = async (params) => {
  return await getOperation("/agent/options", {
    page: 0,
    size: 500,
    ...params,
  });
}
